export default __webpack_public_path__ + "static/the_dance_of_magic-b886034d9154a53fe3a7f2784afc43d4.png";